module.exports = __webpack_public_path__ + "static/fonts/iconfont.6f00b6c.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/iconfont.ttf?t=1559020008880
// module id = MiNg
// module chunks = 96